import { DialogConfig } from '@agent-ds/shared/components/dialog/dialog-config';
import { DialogService } from '@agent-ds/shared/services';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomerFilterDialogComponent } from './customer-filter-dialog.component';

export type CustomerFilterFieldType = 'number' | 'select' | 'text';

export interface CustomerFilterOption {
  label: string;
  value: string | number | unknown[];
}

export interface CustomerFilterDefinition {
  key: string;
  label: string;
  type: CustomerFilterFieldType;
  options?: CustomerFilterOption[];
}

export interface CustomerFilterCondition {
  key: string;
  value: string | number | unknown[];
}

@Component({
  selector: 'ag-customer-filter-button-and-dialog',
  templateUrl: './customer-filter-button-and-dialog.component.html',
  styleUrls: ['./customer-filter-button-and-dialog.component.scss'],
})
export class CustomerFilterButtonAndDialogComponent {
  @Input() buttonLabel = '検索条件';
  @Input() filterDefinitions: CustomerFilterDefinition[] = [];
  @Input() currentConditions: CustomerFilterCondition[] = [];
  @Output() readonly filtersChange = new EventEmitter<CustomerFilterCondition[]>();

  constructor(private dialogService: DialogService) {}

  get currentConditionsLabel(): string {
    return this.currentConditions
      .map((condition) => this.formatConditionLabel(condition))
      .filter((label): label is string => !!label)
      .join(' / ');
  }

  openDialog(): void {
    const dialogRef = this.dialogService.open(CustomerFilterDialogComponent, {
      data: {
        filterDefinitions: this.filterDefinitions,
        currentConditions: this.currentConditions,
      },
    } as DialogConfig);

    dialogRef.afterClosed.subscribe((conditions?: CustomerFilterCondition[]) => {
      if (conditions) {
        this.filtersChange.emit(conditions);
      }
    });
  }

  getDefinition(key: string): CustomerFilterDefinition | undefined {
    return this.filterDefinitions.find((definition) => definition.key === key);
  }

  private formatConditionLabel(condition: CustomerFilterCondition): string | null {
    const definition = this.getDefinition(condition.key);

    if (!definition || condition.value === null || condition.value === '') {
      return null;
    }

    if (definition.type === 'select') {
      const option = definition.options
        ? definition.options.find((item) => item.value === condition.value)
        : undefined;
      return option ? `${definition.label}: ${option.label}` : null;
    }

    return `${definition.label}: ${String(condition.value)}`;
  }
}
